import {formGroup, getFullFormName, VteGroupsSettings} from './vte_data';
import Notes from '../../../../util/notes';
import React from 'react';
import moment from 'moment/moment';
import InformationBox from '../../../../components/other/informationBox';
import {getConfig} from '../../../../util/configUtil';
import {FormLabel} from '@mui/material';

const getQuestionsText = (formToView, type, saveAllValues, classes) => {
    let questions = [];

    Object.keys(formToView?.values[type]).forEach((key, index) => {
        questions.push(
            <li
                key={index + type}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                &bull; {formToView[type + 'Texts'][key]}
                {saveAllValues &&
                    <div className={classes.outcomeQuestionsIndicator}>
                        <b>
                            {saveAllValues && (formToView.values[type][key] ? ' Yes' : ' No')}
                        </b>
                    </div>
                }
            </li>,
        );
    });

    if (!questions.length) return [<div key="none"> None </div>];
    return questions;
};

export const createNotesForVte = (formToNote) => {
    let formSettings = VteGroupsSettings[formGroup[formToNote.type]];
    return Notes.getVTENote(formToNote, formSettings);
};

export const getOutcomeView = (formToView, classes, t) => {
    let sets = [];
    let formSettings = VteGroupsSettings[formGroup[formToView.type]];

    formSettings.components.forEach((component, index) => {
        sets.push(
            <div key={index} className={classes.borderBottom}>
                <FormLabel style={{fontWeight: 'bold'}}>
                    {t(component.label)}:
                </FormLabel>

                <ul>
                    {getQuestionsText(formToView, component.set, component?.saveAllValues, classes)}
                </ul>
            </div>,
        );
    });

    return (
        <div className={classes.formView}>
            <div className={classes.titleLabel}>
                <div>
                    {getFullFormName(formToView.type)}
                </div>

                <div style={{fontSize: 10, textAlign: 'right'}}>
                    Created
                    by: {formToView?.createdWho} @ {moment(formToView?.createdWhen).format(getConfig('defaultDateTimeFormat'))}
                </div>
            </div>

            {sets}

            <InformationBox type="info">
                Outcome
                <br/>
                {formToView?.outcome}
            </InformationBox>

            <InformationBox type="warning">
                {formSettings.staticOutcomeWarning}
            </InformationBox>
        </div>
    );
};